export default function contactEmail() {
  return window ? window.contactEmail : '';
}
